module.exports = __webpack_public_path__ + "static/sidepanel-9beeb3d8b19ba79c630eb7eff796da0e.png";